<template>
  <div class="integracoes-painel">
    <BannerInformativoPainelIntegracoes />
    <PainelIntegracoesTable />
  </div>
</template>

<script setup lang="ts">
import { diContainer } from "@/inversify.config";
import BannerInformativoPainelIntegracoes from "../../components/BannerInformativoPainelIntegracoes.vue";
import { painelIntegracoesContainer } from "./container/painelIntegracoesContainer";
import { cadastroDeIntegracaoContainer } from "./widgets/cadastro/container/cadastroDeIntegracao";
import PainelIntegracoesTable from "./widgets/table/PainelIntegracoesTable.vue";
import { onUnmounted } from "vue";

diContainer.load(painelIntegracoesContainer);
diContainer.load(cadastroDeIntegracaoContainer);

onUnmounted(() => {
  diContainer.unload(painelIntegracoesContainer);
  diContainer.unload(cadastroDeIntegracaoContainer);
});
</script>

<style lang="scss" scoped></style>
